<script>
    export let label;
    export let process;
    export let disabled;
    export let variant = 'pure__button--base';
    $: value = label;
    export let onClick = () => {};
    let updateBlock = () => {
        value = process;
    };
</script>

<button
    type="button"
    class="pure__button {variant}"
    {disabled}
    on:click={() => {
        if (!disabled) onClick();
        updateBlock();
    }}>{value}</button
>
